import { OverlayArrow } from 'react-aria-components';
import clsx from 'clsx';

import styles from './TooltipArrow.module.css';

type Props = {
  theme?: 'light' | 'dark';
};

export function TooltipArrow({ theme = 'dark' }: Props) {
  return <OverlayArrow className={clsx(styles.arrow, styles[theme])} />;
}
